var _classCallCheck = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var RDFaProcessor = require('rdfa-processor').RDFaProcessor;

var DataFactory = require('@rdfjs/data-model');

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function _class(options) {
    _classCallCheck(this, _class);

    this.documentIRI = options.documentIRI;
    this.factory = options.factory || DataFactory;
  }

  _createClass(_class, [{
    key: "parse",
    value: function parse(document, callback) {
      try {
        var processor = new RDFaProcessor(null, this.factory);

        processor.onTriple = function (triple) {
          callback(null, triple);
        };

        processor.process(document, {
          baseURI: this.documentIRI
        });
      } catch (e) {
        callback(e);
      }
    }
  }]);

  return _class;
}();